var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('navigation'),_c('v-content',[_c('loading'),_c('notification'),_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}]})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }